import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '../Button'
import { faCalendar, faCalendarXmark } from '@fortawesome/free-regular-svg-icons'
import { faCalendarCheck, faLocation, faLocationDot, faLocationPin, faMapLocation } from '@fortawesome/free-solid-svg-icons'

export type IArticle = {
	id?: number
	heading: string
	introduction?: string
	imageUrl?: string
	author?: string,
	address?: string,
	categoryTypes?: string[]
	url?: string
	updatedDate?: string
	dateUpdated?: string,
	publishedDate?: string,
	showForGuestUser?: boolean,
	showForLoggedInUser?: boolean,
	callToActionName?: string,
	dateOfEvent?: string,
	timeOfEvent?: string,
	contentType?: string,
	BGColor?: string
}

interface IProps {
	article: IArticle
	className?: string
	theme: string
	showAuthor?: boolean
	showDate?: boolean,
	showTime?: boolean,
	showAddress?: boolean,
	showCalendar?: boolean,
	callToActionName?: string,
	ctaFitContent? : boolean
	height?: string,
	introLineClamp?: number,
	minHeight?: string
}

export default function Panel({article, theme, showAuthor = false, showTime, className, showDate = false, ctaFitContent, height, showAddress, showCalendar, introLineClamp}: IProps) {

	const bgClass = theme == 'dark' ? 'bg-sky-800 text-white' : 'bg-surface-20 text-sky-800'

	return (
		<div className={[className].join(' ')}>
			<a
				href={article.url}
				className={`relative flex flex-col w-full h-full overflow-hidden cursor-pointer rounded-xl ${bgClass} group`}
			>
				{
					article.imageUrl && (
						<div className="relative overflow-hidden min-h-[207px] rounded-xl aspect-[3/2]">
							<img
								alt={article.heading}
								src={article.imageUrl}
								className="object-cover w-full h-full aspect-[3/2] overflow-hidden duration-500 group-hover:scale-110"
							/>
						</div>
					)
				}
				<div className={`relative z-20 flex flex-col flex-wrap grow relative z-20 p-6 text-left h-full rounded-b-xl ${bgClass} ${article.imageUrl ? '' : 'justify-between'}`}>
					{
						showAuthor || showDate ? (
							<div className="justify-start items-center gap-2 inline-flex mb-5">
								{
									showAuthor && (
										<div className="text-sm font-bold leading-tight">
											{article.author}
										</div>
									)
								}
								{ (showAuthor && article.author) && (showDate && (article.updatedDate || article.publishedDate)) && <div className={`w-1 h-1 rounded-full ${theme == 'dark' ? 'bg-slate-200' : 'bg-sky-800'}`} /> }
								{
									showDate && (
										<div className="text-sm font-bold leading-tight">
											{article.updatedDate ? article.updatedDate : article.publishedDate}
										</div>
									)
								}
							</div>
						) : ''
					}



					<div className={`flex flex-col mb-5 w-full`}>
						<div className={article.imageUrl ? '' : 'grow'}>
							<h3 className={`font-museo mb-5 text-2xl leading-none normal-case line-clamp-3 ${bgClass}`}>
								{article.heading}
							</h3>
							{
								showCalendar && (
									<div className='flex items-center mb-2 md:mt-0 mt-4 text-md font-bold'>
										<FontAwesomeIcon icon={faCalendar} className='mr-2' />
										<div>
											{article.dateOfEvent}
										</div>
										{ showCalendar && showTime && <div className={`mx-2 w-1 h-1 rounded-full ${theme == 'dark' ? 'bg-slate-200' : 'bg-sky-800'}`} /> }
										<div>
											{article.timeOfEvent}
										</div>
									</div>
								)
							}
							{
								showAddress && (
									<div className='flex items-center mb-4 w-full text-md font-bold'>
										<FontAwesomeIcon icon={faLocationDot} className='mr-2' />
										<div className="leading-tight">
											{article.address}
										</div>
								</div>
								)
							}
							<p className={[`line-clamp-3 md:line-clamp-${introLineClamp ? introLineClamp : '3'} text-text-color-80 prose`, theme == "dark" && "!text-white"].join(" ")}>
								{article.introduction}
							</p>
						</div>
					</div>

					<Button
						type={theme == "dark" ? "secondary-alt" : "primary"}
						size='sm'
						className='block max-w-[200px] mt-auto'
						fitContent={ctaFitContent}
					>
						{article.callToActionName ? article.callToActionName : 'Find out more'}
					</Button>
				</div>
			</a>
		</div>
	)
}
